import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/index.css';
import 'remixicon/fonts/remixicon.css';
import './i18n';

import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initSentry } from './instrument';
import { App } from './App';
import { LanguageProvider } from './providers/LanguageProvider';

if (import.meta.env.PROD) {
  initSentry();
}

const qClient = new QueryClient({});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={qClient}>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
